import { useState, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { intersection_threshold, url } from '../../base/Variables'
import { CategoryCard, CategoryPlaceholder } from '../index'
import { useDispatch } from 'react-redux'
import { getTopCategory, setSuggestedProduct } from '../../redux/AppSlice'
import { LazyAxios } from '../../base'

function TopCategory() {
    const [loading, setLoading] = useState(true)
    const top_category = useSelector((state) => state.appSlice.top_category)
    const dispatch = useDispatch()
    const componentRef = useRef(null)
    const baseUrl = `${url}/api/v1/product`

    async function getdddTopCategory() {
        setLoading(true)
        try {
            const axios = await LazyAxios()
            const request = await axios.get(`${baseUrl}/getTopCategory/`)
            if (request.data && request.data.data) {
                dispatch(setSuggestedProduct({ 'type': 'top_category', 'data': request.data.data }))
            }
        }
        catch (error) {
        }
        finally {
            setLoading(false)
        }

    }

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                // Check if the child component is in the viewport
                if (entries[0].isIntersecting && loading) {
                    // Trigger the API call or any function passed as prop
                    if (top_category === null) {
                        dispatch(getTopCategory())
                    }
                    else {
                        setLoading(false)
                    }
                }
            },
            {
                root: null, // default to the viewport
                threshold: intersection_threshold, // 30% of the component must be visible
            }
        );

        if (componentRef.current) {
            observer.observe(componentRef.current);
        }

        return () => {
            if (componentRef.current) {
                observer.unobserve(componentRef.current);
            }
        };
    }, [top_category, loading])


    console.log(top_category)

    return (
        <div className='mt-5 topCategory container' ref={componentRef}>
            {
                loading ? <CategoryPlaceholder /> :
                    top_category ? <>
                        <div >
                            <div className='heading h4'>Our Premium Collection</div>
                            <div className='text-center h6 mt-2'>" Discover the Finest Maheshwari Weaves – <br className='d-md-none' /> From Silk Elegance to Handcrafted Dupattas "</div>
                        </div>
                        <div style={{ display: 'flex', gap: '30px', marginTop: '30px', width: '100%', overflowX: 'scroll', scrollbarWidth: 'none' }}>
                            {
                                top_category.map((item, index) => {
                                    return index < 7 && <div key={index}>
                                        <CategoryCard category={item} />
                                    </div>
                                })
                            }
                        </div>

                        <div style={{ display: 'flex', gap: '30px', marginTop: '30px', width: '100%', overflowX: 'scroll', scrollbarWidth: 'none' }}>
                            {
                                top_category.map((item, index) => {
                                    return index > 6 && <div key={index}>
                                        <CategoryCard category={item} />
                                    </div>
                                })
                            }
                        </div>
                        <hr className='mt-5' />
                    </> : <></>

            }
        </div>
    )
}


export default TopCategory